import { render, staticRenderFns } from "./AllLeavesDetails.vue?vue&type=template&id=1eb45b7c&"
import script from "./AllLeavesDetails.vue?vue&type=script&lang=js&"
export * from "./AllLeavesDetails.vue?vue&type=script&lang=js&"
import style0 from "./AllLeavesDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports